import React from 'react';
import PropTypes from 'prop-types';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import withStyles from '@mui/styles/withStyles';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { red, lime, indigo } from '@mui/material/colors';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);


const styles = {
    chart: {
        paddingLeft: '15%',
        paddingRight: '15%'
    }
}

class TypesIndicateursAncienneteGraph extends React.Component {

    getData = () => {
        var propsData = [...this.props.indicateurs];

        var labels = [];
        var data = [];

        for (var i = 0; i < propsData.length; i++) {
            labels.push(propsData[i].libelle);
            data.push(propsData[i].ancienneteMoyenne);
        }

        return {
            labels: labels,
            datasets: [{
                data: data,
                backgroundColor: [
                    red[500],
                    lime[500],
                    indigo[500]
                ],
                hoverBackgroundColor: [
                    red[500],
                    lime[500],
                    indigo[500]
                ]
            }]
        };
    }

    getOptions = () => ({
        indexAxis: 'y',
        layout: {
            padding: 12
        },
        scales: {
            xAxis: {
                display: false
            },
            yAxis: {
                display: true
            }
        },
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Ancienneté par type de dossier après-vente',
                position: 'bottom',
                font: {
                    family: 'Roboto',
                    weight: '500'
                }
            },
            tooltip: {
                enabled: false
            },
            datalabels: {

                display: true,

                anchor: 'end',
                backgroundColor: function (context) {
                    return context.dataset.backgroundColor;
                },
                borderColor: 'white',
                borderRadius: 25,
                borderWidth: 2,
                color: 'white',
                font: {
                    weight: 'bold'
                },
                textAlign: 'center'
            }
        }
    });


    render() {

        const data = this.getData();
        //console.log(data);

        const options = this.getOptions();
        //console.log(options);

        return (
            <div className={this.props.classes.chart}>
                <Bar data={data} options={options} />
            </div>
        )
    }
}

TypesIndicateursAncienneteGraph.propTypes = {
    classes: PropTypes.object.isRequired,
    indicateurs: PropTypes.array.isRequired
};

export default withStyles(styles)(TypesIndicateursAncienneteGraph);